import { render, staticRenderFns } from "./MiscellaneousSetting.vue?vue&type=template&id=0b81cc7a"
import script from "./MiscellaneousSetting.vue?vue&type=script&lang=js"
export * from "./MiscellaneousSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports